import { on } from "svelte/events";
import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import { iconRegistryStyles } from "../../../scss/icon/iconRegistryStyles.ts";
import type { Props } from "./ButtonV2.types.ts";

defineComponent<Props>({
  tag: "oc-button-v2",
  extendOptions: { useShadow: false },
  styles: [iconRegistryStyles, () => import("./ButtonV2.global.scss?inline")],
  props: {
    widthBehavior: { attribute: "width-behavior", reflect: true },
    iconLeft: { attribute: "icon-left", reflect: true },
    iconRight: { attribute: "icon-right", reflect: true },
    loading: { type: "Boolean", reflect: true },
    size: { reflect: true },
    success: { type: "Boolean", reflect: true },
    variant: { reflect: true },
  },
  onMount(host) {
    const handleClick = (event: MouseEvent): void => {
      if (!host.loading) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    };

    const offClick = on(host, "click", handleClick, { capture: true });
    /*                                                        */
    /*                                                                                                 */
    const offAuxClick = on(host, "auxclick", handleClick, { capture: true });

    return () => {
      offClick();
      offAuxClick();
    };
  },
});
